var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.1665 3C16.1665 3 4.1665 9 4.1665 17C4.16637 18.1519 4.49784 19.2795 5.12132 20.2482C5.7448 21.2168 6.63392 21.9854 7.6825 22.4623C8.73107 22.9392 9.89476 23.1042 11.0346 22.9376C12.1744 22.7709 13.2421 22.2797 14.1103 21.5225L12.1665 28H20.1665L18.2228 21.5225C19.0909 22.2797 20.1586 22.7709 21.2984 22.9376C22.4382 23.1042 23.6019 22.9392 24.6505 22.4623C25.6991 21.9854 26.5882 21.2168 27.2117 20.2482C27.8352 19.2795 28.1666 18.1519 28.1665 17C28.1665 9 16.1665 3 16.1665 3Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 3C16.1665 3 4.1665 9 4.1665 17C4.16637 18.1519 4.49784 19.2795 5.12132 20.2482C5.7448 21.2168 6.63392 21.9854 7.6825 22.4623C8.73107 22.9392 9.89476 23.1042 11.0346 22.9376C12.1744 22.7709 13.2421 22.2797 14.1103 21.5225L12.1665 28H20.1665L18.2228 21.5225C19.0909 22.2797 20.1586 22.7709 21.2984 22.9376C22.4382 23.1042 23.6019 22.9392 24.6505 22.4623C25.6991 21.9854 26.5882 21.2168 27.2117 20.2482C27.8352 19.2795 28.1666 18.1519 28.1665 17C28.1665 9 16.1665 3 16.1665 3Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpade);
export default __webpack_public_path__ + "static/media/Spade.c77af53534f0ec3220717e39a12bd80f.svg";
export { ForwardRef as ReactComponent };